import { Service, inject } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {GoogleService} from './google-service';
import {Observable} from 'rxjs';
import {EntityCostReport} from '../model/skucost/entity-cost-report';

@Service()
export class SkuCostService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);
  private urlBase = environment.serviceUrl + 'skuCost/';

  getCostReport(entityId: string, revision: number, brandName: string): Observable<EntityCostReport> {
    const url = this.urlBase + 'entityCostReport/' + entityId + '/' + revision + '/' + encodeURIComponent(brandName);
    return this.http.get<EntityCostReport>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
